/**
 * This package's translations.
 *
 * Registered at module load, so importing anything from `feature-iam` brings
 * its strings with it. A feature whose translations had to be wired separately
 * would eventually be added to an application without them, and the symptom —
 * raw keys on screen — appears only in the locales nobody tests.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import ar from "./locales/ar.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

/** The namespace every key in this package lives under. */
export const NAMESPACE = "iam";

registerNamespace(NAMESPACE, { en, fr, es, ar });
